"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("../List"));

var _Tree = _interopRequireDefault(require("../Tree"));

var _Spin = _interopRequireDefault(require("../Spin"));

var _locale = require("../locale");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ScaleList = (0, _List.default)(['fade', 'scale-y'], 'fast');

var OptionList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(OptionList, _Component);

  function OptionList(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = OptionList.prototype;

  _proto.getText = function getText(key) {
    return this.props.text[key] || (0, _locale.getLocale)(key);
  };

  _proto.handleClick = function handleClick(data) {
    var _this$props = this.props,
        datum = _this$props.datum,
        onChange = _this$props.onChange;
    if (datum.disabled(data)) return;
    onChange(null, data);
  };

  _proto.renderItem = function renderItem(data) {
    var _this$props2 = this.props,
        renderItem = _this$props2.renderItem,
        datum = _this$props2.datum;
    return _react.default.createElement("span", {
      className: (0, _styles.selectClass)('tree-node', datum.check(data) && 'selected', datum.disabled(data) && 'disabled')
    }, renderItem(data));
  };

  _proto.renderTree = function renderTree() {
    var _this$props3 = this.props,
        loading = _this$props3.loading,
        treeData = _this$props3.treeData,
        keygen = _this$props3.keygen,
        onExpand = _this$props3.onExpand,
        loader = _this$props3.loader,
        expanded = _this$props3.expanded,
        defaultExpanded = _this$props3.defaultExpanded,
        renderPending = _this$props3.renderPending;
    if (loading) return _react.default.createElement("span", {
      className: (0, _styles.selectClass)('option')
    }, typeof loading === 'boolean' ? _react.default.createElement(_Spin.default, {
      size: 20
    }) : loading);
    if (treeData.length === 0 || renderPending) return _react.default.createElement("span", {
      className: (0, _styles.selectClass)('option')
    }, this.getText('noData'));
    return _react.default.createElement("div", {
      className: (0, _styles.selectClass)('tree-wrapper')
    }, _react.default.createElement(_Tree.default, {
      onClick: this.handleClick,
      line: false,
      data: treeData,
      keygen: keygen,
      renderItem: this.renderItem.bind(this),
      onExpand: onExpand,
      loader: loader,
      expanded: expanded,
      defaultExpanded: defaultExpanded
    }));
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        focus = _this$props4.focus,
        style = _this$props4.style,
        selectId = _this$props4.selectId,
        height = _this$props4.height;
    var mergeStyle = Object.assign({}, {
      maxHeight: height,
      overflowY: 'auto'
    }, style);
    return _react.default.createElement(ScaleList, {
      show: focus,
      style: mergeStyle,
      "data-id": selectId,
      className: (0, _styles.selectClass)('options', 'tree')
    }, this.renderTree());
  };

  return OptionList;
}(_react.Component);

OptionList.propTypes = {
  onChange: _propTypes.default.func,
  loader: _propTypes.default.func,
  defaultExpanded: _propTypes.default.arrayOf(_propTypes.default.string),
  expanded: _propTypes.default.arrayOf(_propTypes.default.string),
  renderPending: _propTypes.default.bool,
  treeData: _propTypes.default.array,
  datum: _propTypes.default.object.isRequired,
  focus: _propTypes.default.bool,
  onExpand: _propTypes.default.func,
  keygen: _propTypes.default.any,
  loading: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  renderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  selectId: _propTypes.default.string,
  style: _propTypes.default.object,
  text: _propTypes.default.object,
  height: _propTypes.default.number
};
var _default = OptionList;
exports.default = _default;